<template>
  <div></div>
</template>

<script>
export default {
  name: 'NotFount',
  data () {
    return {
      canvas: null,
      ctx: null,
      width: 0,
      height: 0,
      word_arr: [],
      txt_min_size: 5,
      txt_max_size: 25,
      keypress: false,
      acclerate: 2
    }
  },
  methods: {
    canvasInit () {
      this.canvas = document.createElement('canvas')
      this.height = this.canvas.height = window.innerHeight
      this.width = this.canvas.width = window.innerWidth
      this.ctx = this.canvas.getContext('2d')
      document.getElementById('app').appendChild(this.canvas)

      for (var i = 0; i < 25; i++) {
        this.word_arr.push({
          x: this.random(0, this.width),
          y: this.random(0, this.height),
          text: '404',
          size: this.random(this.txt_min_size, this.txt_max_size)
        })

        this.word_arr.push({
          x: this.random(0, this.width),
          y: this.random(0, this.height),
          text: 'page',
          size: this.random(this.txt_min_size, this.txt_max_size)
        })

        this.word_arr.push({
          x: this.random(0, this.width),
          y: this.random(0, this.height),
          text: 'not found',
          size: this.random(this.txt_min_size, this.txt_max_size)
        })

        this.word_arr.push({
          x: this.random(0, this.width),
          y: this.random(0, this.height),
          text: '404',
          size: Math.floor(this.random(this.txt_min_size, this.txt_max_size))
        })
      }
    },
    random (min, max) {
      return Math.random() * (max - min + 1) + min
    },
    range_map (value, inMin, inMax, outMin, outMax) {
      return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin
    },
    render () {
      this.ctx.fillStyle = 'rgba(0,0,0,1)'
      this.ctx.fillRect(0, 0, this.width, this.height)
      this.ctx.fillStyle = '#FFF'

      for (var i = 0; i < this.word_arr.length; i++) {
        this.ctx.font = this.word_arr[i].size + 'px sans-serif'
        var w = this.ctx.measureText(this.word_arr[i].text)
        this.ctx.fillText(this.word_arr[i].text, this.word_arr[i].x, this.word_arr[i].y)

        if (this.keypress) {
          this.word_arr[i].x += this.range_map(this.word_arr[i].size, this.txt_min_size, this.txt_max_size, 2, 4) * this.acclerate
        } else {
          this.word_arr[i].x += this.range_map(this.word_arr[i].size, this.txt_min_size, this.txt_max_size, 2, 3)
        }

        if (this.word_arr[i].x >= this.width) {
          this.word_arr[i].x = -w.width * 2
          this.word_arr[i].y = this.random(0, this.height)
          this.word_arr[i].size = Math.floor(this.random(this.txt_min_size, this.txt_max_size))
        }
      }

      this.ctx.fill()

      requestAnimationFrame(this.render)
    }
  },
  mounted () {
    this.canvasInit()
    this.render()
  }
}
</script>

<style scoped>
  .notmsg {
    font-size: 26px;
    color: #FFF;
    display: block;
    overflow: hidden;
    display: block;
    background: rgba(0,0,0,.4);
    padding: 0 40px;
    text-overflow: ellipsis;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/pages/404.vue